const mainGetters = {

  getUser (state) {
    return state.login_user
  }
}

export { mainGetters }
